import React from "react";
import Time from "utils/Time";
import Tooltip from "component/Tooltip";
import useStoreRoom from "store/useStoreRoom";

const CountdownBadge = ({ endsAt }: { endsAt: number }) => {
    const clockOffset = useStoreRoom(state => state.clockOffset);
    const [now, setNow] = React.useState(() => Date.now());
    const remaining = Math.max(0, Math.ceil((endsAt - clockOffset - now) / 1000));
    const isUrgent = remaining <= 30;
    const isWarning = remaining > 30 && remaining <= 90;
    const [emoji, setEmoji] = React.useState<string | null>(null);
    const [emojiKey, setEmojiKey] = React.useState(0);
    const prevPhase = React.useRef<"normal" | "warning" | "urgent">("normal");

    React.useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 1000);

        return () => clearInterval(interval);
    }, []);

    React.useEffect(() => {
        const phase = isUrgent ? "urgent" : isWarning ? "warning" : "normal";

        if(phase !== prevPhase.current) {
            if(phase === "warning") {
                setEmoji("😬");
                setEmojiKey((k) => k + 1);
            } else if(phase === "urgent") {
                setEmoji("🥵");
                setEmojiKey((k) => k + 1);
            }

            prevPhase.current = phase;
        }
    }, [isWarning, isUrgent]);

    const bgColor = isUrgent
        ? "bg-red-500/20 border-red-500/50"
        : isWarning
            ? "bg-amber-500/20 border-amber-500/40"
            : "bg-white/10 border-white/20";

    const textColor = isUrgent
        ? "text-red-400"
        : isWarning
            ? "text-amber-400"
            : "text-white/80";

    return (
        <Tooltip key={emojiKey} text={emoji || ""} visible={!!emoji} placement="bottom" duration={2000} onDismiss={() => setEmoji(null)}>
            <div className={`h-8 px-3 rounded-full border flex items-center justify-center transition-colors duration-300 ${bgColor}`}>
                <span className={`text-xs font-bold tabular-nums transition-colors duration-300 ${textColor}`}>
                    {Time.formatCountdown(remaining)}
                </span>
            </div>
        </Tooltip>
    );
};

export default CountdownBadge;
